export default __webpack_public_path__ + "static/media/lager_822_hero.0408324c.jpg";